<template>
  <div id="content">
    <div class="inner_static">
      <h1 class="tit2">Category</h1>
      <ul id="category">
        <li v-for="(category, index) in this.categories" :key="index">
          <a :style="{ backgroundImage: 'url(' + getCategoryIcon(category.categoryIcon) + ')' }"
              @click="categoryClick(category)">
            <strong class="tit">{{category.categoryCaption}}</strong>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'
import {KG_URL} from '../../../constants/App'

export default {
  data () {
    return {
      categories: []
    }
  },
  methods: {
    init: function () {
      axios.get(KG_URL.PLANNING + '/get-categories')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.categories = response.data.data
          }
        }).catch(error => {
          Api.handleError(error)
        })
    },
    categoryClick: function (category) {
      // 親コンポーネントのイベント実行
      this.$emit('selectCategoryEvent', category)
    },
    getCategoryIcon: function (categoryIcon) {
      return App.getKagullResource(categoryIcon)
    }
  },
  created () {
    this.init()
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/planning/CategoryPanel.vue